export const termsAndConditionsResponse = {
  data: {
    EN: {
      lowes: {
        genericTermsAndConditions:
          'https://apply.syf.com/cs/groups/public/documents/et_tcdoc/e030995.pdf',
        dcTermsAndConditions: '',
        psccTermsAndConditions: '',
      },
    },
    ES: {
      lowes: {
        genericTermsAndConditions:
          'https://apply.syf.com/cs/groups/public/documents/et_tcdoc/e045874.pdf',
        dcTermsAndConditions: '',
        psccTermsAndConditions: '',
      },
    },
  },
};
